import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { CommonTable } from '../../_components/table/common.table';
import { PaperTableHeader } from '../../_components/table/header.table';
import { SearchTableHeader } from '../../_components/table/search.table';
import { logService } from '../../_services/log.service';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';

export function LogIndex() {

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setIsLoading] = useState(false);
    const [filter, setFilter] = useState({ ...TABLE_FILTER });

    useEffect(() => {
        fetchData();
    }, [filter]);

    const fetchData = async () => {
        setIsLoading(true);
        return await logService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'id',
                header: '#',
            },
            {
                accessorKey: 'userName',
                header: 'User',
            },
            {
                accessorKey: 'entityName',
                header: 'Section',
            },
            {
                accessorKey: 'propertyName',
                header: 'Field',
            },
            {
                accessorKey: 'newValue',
                header: 'New Value',
            },
            {
                accessorKey: 'oldValue',
                header: 'Old Value',
            },
        ],
        [],
    );

    return (
        <>
            <PaperTableHeader title="Logs" />

            <SearchTableHeader inputs={[
                { label: "User", name: "userName", onChange: setFilter, value: filter.userName },
                { label: "Section", name: "entityName", onChange: setFilter, value: filter.entityName },
                { label: "Field", name: "propertyName", onChange: setFilter, value: filter.propertyName },
                { label: "New Value", name: "newValue", onChange: setFilter, value: filter.newValue },
                { label: "Old Value", name: "oldValue", onChange: setFilter, value: filter.oldValue },
            ]} />

            <CommonTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />
        </>
    );
}